import { envConfig } from "../env";
import type { MarketConfiguration } from "./const";
import {
  ContentfulEnum,
  CurrencyEnum,
  ElevateMarketEnum,
  LocaleEnum,
  MarketEnum,
  RegionEnum,
  ServiceLocaleEnum,
} from "./const";

const latvia: MarketConfiguration = {
  code: MarketEnum.lv,
  label: "Latvia",
  descriptiveLabel: "Latvian",
  testfreaksClientId: envConfig.NEXT_PUBLIC_EU_TESTFREAKS_CLIENT_ID,
  searchEngineUrl: envConfig.NEXT_PUBLIC_SEARCH_ENGINE_URL,
  contentfulLocale: ContentfulEnum.en,
  contentfulCountry: "Latvia",
  locale: LocaleEnum.lv,
  serviceLocale: ServiceLocaleEnum.lv,
  language: {
    code: "en",
    label: "English",
    flag: "gb",
  },
  currency: CurrencyEnum.eur,
  link: "https://www.no-ga.com/en-lv",
  termsSlug: "terms-online",
  loop54Market: MarketEnum.lv,
  adyenMarket: MarketEnum.lv,
  elevateMarket: ElevateMarketEnum.eu,
  freeShippingThreshold: 100,
  freeShippingEnabled: false,
  externalStoreId: "ecom-noga",
  searchPathName: "search",
  adyenCheckoutEnabled: true,
  walleyCheckoutEnabled: false,
  hasTrustPilot: false,
  region: RegionEnum.europe,
  norceImageCdn: ["local", "dev", "stage"].includes(
    process.env.NEXT_PUBLIC_ENVIRONMENT ?? "",
  )
    ? "https://media.stage.cdn-norce.tech/1413"
    : "https://cdn.no-ga.com",
};

export default latvia;
